import { createSelector } from 'reselect';
import { urls as leadFormConfigUrl } from 'Reducers/leadFormConfig';
import { paramsToQueryString } from 'Helpers/url';
import { getSelectedLangCode } from 'Selectors/config';
import { getType } from 'Reducers/helpers/typeModifier';

export const getLangParams = state => {
    const langParams = {
        lang: getSelectedLangCode(state)
    };

    return langParams.lang ? langParams : null;
};

export const leadFormConfigSelector = createSelector(
    state => state.leadFormConfig,
    getLangParams,
    (leadFormConfigObj, langParams) => {
        const url = leadFormConfigUrl.getLeadFormConfig;

        return langParams ? leadFormConfigObj.collections[getType('LEAD_FORM_CONFIG', `${url}?${paramsToQueryString(langParams)}`)] : leadFormConfigObj.collections[getType('LEAD_FORM_CONFIG', url)];
    }
);
